<template>
    <v-treeview :items="itemsTree">
        <template v-slot:label="{ item }">
            <div>
                {{item.name}} : <strong> {{ item.value }}</strong> <br/>
            </div>
        </template>
    </v-treeview>
</template>

<script>
import SMPNum from "@/SMPNum";

export default {
    name: "GroupTimeToKillInTreeView",
    props: ['payload'],
    watch: {
        payload(newVal, oldVal){
            if (oldVal) {
                // optional: clean up or nullify old references
                oldVal = null;
            }
        }
    },
    data() {
        return {
        }
    },
    methods: {
        getTTKG(){
            return {
                id: 1,
                name: 'TTKG',
                value: this.timeToKillGhostReadable,
                children: [{
                    id: 2,
                    name: 'GHP',
                    value: this.kpiGhostHp,
                }, {
                    id: 3,
                    name: 'ΣDPS',
                    value: this.kpiTotalDpsKillGhost,
                    children: [{
                        id: 4,
                        name: 'HeroDPS',
                        value: this.kpiHeroDpsOnGhost,
                        children: [{
                            id: 5,
                            name: `TapDmg(${this.kpiHeroLevelOnGhost})`,
                            value: this.kpiHeroBaseDmgOnGhost,
                        }, {
                            id: 6,
                            name: 'PetElementTypeDmg',
                            value: this.kpiDmgPetElementType,
                        } , {
                            id: 10,
                            name: 'HitPerSecond',
                            value: this.hitPerSecondOnGhost,
                        }]
                    }, {
                        id: 7,
                        name: 'SupportDPS',
                        value: this.kpiSupportDpsOnGhost,
                    }, {
                        id: 8,
                        name: 'PetDPS',
                        value: this.kpiPetDpsOnGhost,
                    }, {
                        id: 9,
                        name: 'ItemDPS',
                        value: this.kpiItemDpsOnGhost,
                    }
                    ],
                },
                ],
            };
        },

        getFTT(){
            return {
                id: 20,
                name: 'FTT',
                value: this.kpiTimeFarming,
                children: [{
                    id: 21,
                    name: 'NTL',
                    value: this.heroNextLevel,
                }, {
                    id: 22,
                    name: '$GAP',
                    value: this.totalCostHeroNextLevel,
                }, {
                    id: 23,
                    name: `FT(${this.gameLevel})`,
                    value: this.kpiFarmingRequiredToLevelUp,
                }, {
                    id: 24,
                    name: 'HTKG',
                    value: this.hitPerGhosts,
                    children: [
                        {
                            id: 25,
                            name: 'GHP',
                            value: this.kpiGhostHp,
                        }, {
                            id: 26,
                            name: 'HeroTapDmg',
                            value: this.kpiHeroBaseDmgOnGhost,
                        }, {
                            id: 27,
                            name: `HLv(${this.kpiHeroLevelOnGhost}) vs GLv(${this.gameLevel})`,
                            value: this.heroLvVsGhostLv,
                        },
                    ],
                }
                ],
            };
        },

        getTG(){
            return {
                id: 40,
                name: '$G Total',
                value: this.kpiCumulatedGoldWon,
                children: [{
                    id: 41,
                    name: '$G Begin',
                    value: this.beginGold,
                }, {
                    id: 42,
                    name: '$G WaveFarm',
                    value: this.goldCanFarm,
                    children: [{
                            id: 43,
                            name: 'Ghost Gold',
                            value: this.kpiGoldDropCurrentLevel,
                        } , {
                            id: 44,
                            name: 'Ghost wave',
                            value: this.kpiWaveValue,
                        }
                    ],
                }, {
                    id: 45,
                    name: '$G FarmBonus',
                    value: this.kpiGoldBonusFromSkill,
                    children: [{
                        id: 47,
                        name: 'Percentage',
                        value: this.kpiPercentageGoldAllBonus,
                    },
                    ],
                }, {
                    id: 46,
                    name: `$G Item`,
                    value: this.kpiGoldItemBonus,
                },
                ],
            };
        },

        getHL(){
            return {
                id: 60,
                name: 'HeroPLvB',
                value: this.heroLevelAfterFarm,
                children: [
                    {
                        id: 61,
                        name: 'HLvAutoPlay',
                        value: this.kpiHeroLevel,
                    }, {
                        id: 62,
                        name: 'HLvAfterFarm',
                        value: this.heroLevelFarm,
                        children: [
                            {
                                id: 63,
                                name: '$G HLv Spent',
                                value: this.kpiCumulatedGoldHeroSpent,
                                children: [
                                    {
                                        id: 64,
                                        name: '$G Total',
                                        value: this.kpiCumulatedGoldWon,
                                    }, {
                                        id: 65,
                                        name: '$G% HLv',
                                        value: this.kpiRatioAllocatedToHeroLv,
                                    },
                                ],
                            }
                        ],
                    },
                ],
            };
        },
    },

    computed: {
        itemsTree(){
            const items = [];
            items.push(this.getTTKG());
            items.push(this.getFTT());
            items.push(this.getTG());
            items.push(this.getHL());
            return items;
        },

        gameLevel () {
            const {kpiGameLevel} = this.payload;
            return kpiGameLevel;
        },
        kpiDmgPetElementType(){
            const {heroDmgSessionFromPet} = this.payload;

            if(heroDmgSessionFromPet.bonusDmg.isZero){
                return '0';
            } else{
                return heroDmgSessionFromPet.bonusDmg.ToReadableAlphabetV2();
            }
        },
        kpiDmgFromBossElementType(){
            const {heroDmgSessionGainBoss} = this.payload;

            if(heroDmgSessionGainBoss.bonusPercent === 0){
                return '0';
            } else if(heroDmgSessionGainBoss.isGain){
                return `+${heroDmgSessionGainBoss.bonusDmg.ToReadableAlphabetV2()}`;
            } else {
                return `-${heroDmgSessionGainBoss.bonusDmg.ToReadableAlphabetV2()}`;
            }
        },
        isNormalBossMode (){
            const {bossInfo} = this.payload;
            if (bossInfo.kpiBossType === 'NormalBoss') {
                return true;
            }
            return false;
        },

        //TTKG Tree
        timeToKillGhostReadable() {
            const {kpiKillGhostPayLoad: {timeToKillGhost}} = this.payload;
            return SMPNum.ToReadableTimeValue(timeToKillGhost);
        },
        kpiGhostHp() {
            const {kpiGhostHp} = this.payload;
            return kpiGhostHp.ToReadableAlphabetV2();
        },
        kpiTotalDpsKillGhost(){
            const {kpiKillGhostPayLoad: {totalDps}} = this.payload;
            return totalDps.ToReadableAlphabetV2();
        },
        kpiHeroDpsOnGhost() {
            const {kpiKillGhostPayLoad: {heroDps}} = this.payload;
            return heroDps.ToReadableAlphabetV2();
        },
        kpiPetDpsOnGhost() {
            const {kpiKillGhostPayLoad: {petDps}} = this.payload;
            return petDps.ToReadableAlphabetV2();
        },
        kpiSupportDpsOnGhost() {
            const {kpiKillGhostPayLoad: {supportDps}} = this.payload;
            return supportDps.ToReadableAlphabetV2();
        },
        kpiItemDpsOnGhost(){
            const {kpiKillGhostPayLoad: {itemDps}} = this.payload;
            return itemDps.ToReadableAlphabetV2();
        },
        kpiHeroLevelOnGhost(){
            const {kpiKillGhostPayLoad: {heroLevel}} = this.payload;
            return heroLevel;
        },
        hitPerSecondOnGhost(){
            const {kpiKillGhostPayLoad: {hitPerSecond}} = this.payload;
            return hitPerSecond;
        },
        kpiHeroBaseDmgOnGhost() {
            const {kpiKillGhostPayLoad: {heroDmg}} = this.payload;
            return heroDmg.ToReadableAlphabetV2();
        },

        //FTT
        kpiTimeFarming() {
            const {kpiTimeFarming} = this.payload;
            return SMPNum.ToReadableTimeValue(kpiTimeFarming);
        },
        kpiFarmingRequiredToLevelUp() {
            const {kpiFarmingTargetRequiredToUpdateHeroToNextLevel} = this.payload;
            return kpiFarmingTargetRequiredToUpdateHeroToNextLevel.ToReadableAlphabetV2();
        },
        heroNextLevel () {
            const {kpiHeroNextLevelInfo: {heroNextLevel}} = this.payload;
            return heroNextLevel;
        },
        totalCostHeroNextLevel() {
            const {kpiHeroNextLevelInfo: {totalCostHeroNextLevel}} = this.payload;
            return totalCostHeroNextLevel.ToReadableAlphabetV2();
        },
        hitPerGhosts() {
            const {kpiHitsPerGhost} = this.payload;
            return kpiHitsPerGhost;
        },
        heroLvVsGhostLv(){
            const {kpiGameLevel, kpiHeroLevel} = this.payload;
            let lv = kpiHeroLevel - kpiGameLevel;
            if(lv > 0){
                return "+"+lv;
            }
            return lv;
        },

        //Total Gold
        kpiCumulatedGoldWon (){
            const {kpiCumulatedGoldWon} = this.payload;
            return kpiCumulatedGoldWon.ToReadableAlphabetV2();
        },
        kpiGoldItemBonus(){
            const {kpiGoldItemBonus} = this.payload;
            return kpiGoldItemBonus.ToReadableAlphabetV2();
        },
        beginGold(){
            const {beginGold} = this.payload;
            return beginGold.ToReadableAlphabetV2();
        },
        goldCanFarm(){
            const {goldCanFarm} = this.payload;
            return goldCanFarm.ToReadableAlphabetV2();
        },
        kpiWaveValue(){
            const {kpiWaveValue} = this.payload;
            return kpiWaveValue;
        },
        kpiGoldDropCurrentLevel(){
            const {kpiGoldDropCurrentLevel} = this.payload;
            return kpiGoldDropCurrentLevel.ToReadableAlphabetV2();
        },
        kpiPercentageGoldAllBonus (){
            const {kpiPercentageGoldAllBonus} = this.payload;
            return (kpiPercentageGoldAllBonus*100)+'%';
        },
        kpiGoldBonusFromSkill(){
            const {kpiGoldBonusFromSkill} = this.payload;
            return kpiGoldBonusFromSkill.ToReadableAlphabetV2();
        },

        //getHL => Hero level info
        kpiHeroLevel(){
            const {kpiHeroLevel} = this.payload;
            return kpiHeroLevel;
        },
        heroLevelAfterFarm(){
            const {heroLevelAfterFarm} = this.payload;
            return heroLevelAfterFarm;
        },
        heroLevelFarm(){
            const {heroLevelAfterFarm, kpiHeroLevel} = this.payload;
            let lvFarm = heroLevelAfterFarm - kpiHeroLevel;
            if(lvFarm > 0){
                return '+'+lvFarm;
            }
            return "0";
        },
        kpiCumulatedGoldHeroSpent(){
            const {kpiCumulatedGoldHeroSpent} = this.payload;
            return kpiCumulatedGoldHeroSpent.ToReadableAlphabetV2();
        },
        kpiRatioAllocatedToHeroLv () {
            const {kpiCumulatedGoldHeroSpent, kpiCumulatedGoldWon} = this.payload;
            if(kpiCumulatedGoldWon.isZero){
                return '0%';
            }
            let p = SMPNum.divSmpNum(kpiCumulatedGoldHeroSpent, kpiCumulatedGoldWon);
            return SMPNum.multSmpNum(p, new SMPNum(100)).ToReadableAlphabetV2()+"%";
        },
    }
}
</script>

<style scoped>
    >>> .v-treeview-node__root {
        min-height: 30px;
    }
</style>